import { Font } from "@react-pdf/renderer";

interface fontFamily {
  family: string;
  fonts: {
    [key: string]: any;
    src: string;
    fontStyle?: string | undefined;
    fontWeight?: string | number | undefined;
  }[];
}

const registerFonts = (fontFamilies: fontFamily[]) => {
  fontFamilies.map((fontFamily) => Font.register(fontFamily));
};

export default registerFonts;
